import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'antd';
import Titulo from 'components/Titulo';
import InputTextArea from 'components/InputTextArea';

export default function ContainerJustificativa({ control, onChange, errors, disabled }) {
  return (
    <Col span={24}>
      <Titulo textTitle="Justificativa" />
      <InputTextArea
        label={'* Dúvida ou Observação'}
        name="justificativa"
        errors={errors}
        placeholder="Escreva a sua dúvida ou observação sobre o requerimento solicitado"
        control={control}
        onChange={onChange}
        maxLength={2000}
        rows={8}
        disabled={disabled}
      />
    </Col>
  );
}

ContainerJustificativa.propTypes = {
  control: PropTypes.object,
  onChange: PropTypes.func,
  errors: PropTypes.object,
  disabled: PropTypes.bool,
  tipoFormulario: PropTypes.number,
};
